<div class="zag-dropdown-menu__wrapper">
  <button type="button" class="zag-dropdown-menu__trigger" (click)="toggle()" [attr.aria-haspopup]="'true'" [attr.aria-expanded]="isOpen()">
    @if (triggerTemplate) {
    <ng-container [ngTemplateOutlet]="triggerTemplate"></ng-container>
    }
  </button>

  @if (isOpen()) {
  <div class="zag-dropdown-menu__content" role="menu" [attr.aria-hidden]="!isOpen()">
    <ng-content></ng-content>
  </div>
  }
</div>
